import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:flex-row lg:justify-between" }
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = {
  class: "block required",
  for: "serviceName"
}
const _hoisted_4 = {
  class: "block required",
  for: "serviceOnlineName"
}
const _hoisted_5 = { class: "block required" }
const _hoisted_6 = { class: "block required" }
const _hoisted_7 = { class: "block required" }
const _hoisted_8 = { class: "block required" }
const _hoisted_9 = ["for"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "w-52" }
const _hoisted_12 = { class: "block" }
const _hoisted_13 = { class: "flex justify-between items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_15 = { class: "block" }
const _hoisted_16 = { class: "flex gap-x-2" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex justify-end gap-2" }

import PMultiselect from "primevue/multiselect";
import PListbox from "primevue/listbox";
import CTimePicker from "@/components/TimePicker.vue";
import CButton from "@/components/Button.vue";
import PInputNumber from "primevue/inputnumber";
import inputText from "primevue/inputtext";
import { ref, computed } from "vue";
import { cloneDeep } from "lodash";
import { useVuelidate } from "@vuelidate/core";
import FormErrors from "@/components/FormErrors.vue";
import { useStore } from "vuex";
import { useConfirm } from "primevue/useconfirm";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'serviceForm',
  props: {
  service: {
    type: Object,
    default: () => ({ spaces: [] }),
  },
  isUpdate: {
    type: Boolean,
    default: false,
  },
},
  emits: ["cancel", "save"],
  setup(__props, { emit }) {

const props = __props;

const confirm = useConfirm();
const store = useStore();
const { t } = useI18n();


const daysOfWeek = computed(() => {
  return [
    { name: t("daysOfWeek.MONDAY"), id: "MONDAY" },
    { name: t("daysOfWeek.TUESDAY"), id: "TUESDAY" },
    { name: t("daysOfWeek.WEDNESDAY"), id: "WEDNESDAY" },
    { name: t("daysOfWeek.THURSDAY"), id: "THURSDAY" },
    { name: t("daysOfWeek.FRIDAY"), id: "FRIDAY" },
    { name: t("daysOfWeek.SATURDAY"), id: "SATURDAY" },
    { name: t("daysOfWeek.SUNDAY"), id: "SUNDAY" },
  ];
});
const spaces = computed(() => {
  return cloneDeep(
    (store.getters["pos/spaces"] ?? []).filter((space: any) => {
      let alreadyAdded = false;
      alreadyAdded = service.value.spaces.find(
        (serviceSpace: any) => serviceSpace.id === space.id
      );
      return !alreadyAdded;
    })
  );
});
const rules = props.isUpdate
  ? store.getters["service/rulesToUpdateAService"]
  : store.getters["service/rulesToCreateAService"];
let service = ref(cloneDeep(props.service));
const v$ = useVuelidate(rules, service, { $lazy: true });
const cancel = () => {
  emit("cancel");
  service.value = cloneDeep(props.service);
};
const save = async () => {
  if (await v$.value.$validate()) {
    emit("save", cloneDeep(service.value));
  }
};
const addSpace = (space: any) => {
  service.value.spaces.push(cloneDeep(space));
};
const removeSpace = (spaceIndex: number) => {
  confirm.require({
    message: `${t("deletingSpace")} ${
      service.value.spaces[spaceIndex].name ?? ""
    }`,
    header: t("confirmation"),
    icon: "pi pi-exclamation-triangle",
    accept: () => {
      service.value.spaces.splice(spaceIndex, 1);
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "flex flex-col gap-y-2",
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("serviceName")), 1),
            _createVNode(_unref(inputText), {
              class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).name.$invalid }]),
              id: "serviceName",
              type: "text",
              modelValue: _unref(v$).name.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
              autocomplete: "off"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(FormErrors, {
              errors: _unref(v$).name.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("onlineName")), 1),
            _createVNode(_unref(inputText), {
              class: _normalizeClass(["w-full", { 'p-invalid': _unref(v$).onlineName.$invalid }]),
              id: "serviceOnlineName",
              type: "text",
              modelValue: _unref(v$).onlineName.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).onlineName.$model) = $event)),
              autocomplete: "off"
            }, null, 8, ["modelValue", "class"]),
            _createVNode(FormErrors, {
              errors: _unref(v$).onlineName.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("onlineAvailablePlaces")), 1),
            _createVNode(_unref(PInputNumber), {
              class: "w-full",
              mode: "decimal",
              showButtons: "",
              step: 1,
              min: 0,
              modelValue: _unref(v$).onlineAvailablePlaces.$model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).onlineAvailablePlaces.$model) = $event)),
              buttonLayout: "horizontal",
              incrementButtonIcon: "pi pi-plus",
              decrementButtonIcon: "pi pi-minus"
            }, null, 8, ["modelValue"]),
            _createVNode(FormErrors, {
              errors: _unref(v$).onlineAvailablePlaces.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("averageDuration")), 1),
            _createVNode(CTimePicker, {
              class: "w-full",
              modelValue: _unref(v$).averageDuration.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).averageDuration.$model) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(FormErrors, {
              errors: _unref(v$).averageDuration.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("delayBetweenSlots")), 1),
            _createVNode(CTimePicker, {
              class: "w-full",
              modelValue: _unref(v$).delayBetweenSlots.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).delayBetweenSlots.$model) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(FormErrors, {
              errors: _unref(v$).delayBetweenSlots.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("openingDays")), 1),
            _createVNode(_unref(PMultiselect), {
              class: "w-full",
              placeholder: _ctx.$t('weekDays'),
              options: _unref(daysOfWeek),
              "option-label": "name",
              "option-value": "id",
              "data-key": "id",
              modelValue: _unref(v$).openDays.$model,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).openDays.$model) = $event))
            }, _createSlots({ _: 2 }, [
              (_unref(v$).openDays.$model?.length === _unref(daysOfWeek)?.length)
                ? {
                    name: "value",
                    fn: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("everyDay")), 1)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["placeholder", "options", "modelValue"]),
            _createVNode(FormErrors, {
              errors: _unref(v$).openDays.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", {
              class: "block required",
              for: `service-starts-at-${_unref(service).id}`
            }, _toDisplayString(_ctx.$t("serviceStartingAt")), 9, _hoisted_9),
            _createVNode(CTimePicker, {
              modelValue: _unref(v$).startingAt.$model,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).startingAt.$model) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(FormErrors, {
              errors: _unref(v$).startingAt.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", {
              class: "block required",
              for: `service-ends-at-${_unref(service).id}`
            }, _toDisplayString(_ctx.$t("serviceEndingAt")), 9, _hoisted_10),
            _createVNode(CTimePicker, {
              modelValue: _unref(service).endingAt,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(service).endingAt) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(FormErrors, {
              errors: _unref(v$).endingAt.$errors
            }, null, 8, ["errors"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("spacesList")), 1),
        _createVNode(_unref(PListbox), {
          options: _unref(spaces),
          optionLabel: "name",
          listStyle: "max-height:250px"
        }, {
          option: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1),
              _createVNode(CButton, {
                class: "p-button-xs",
                onClick: ($event: any) => (addSpace(slotProps.option))
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["options"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("spaces")), 1),
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(service).spaces, (space, spaceIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: spaceIndex,
            class: "rounded-xl bg-gray-200 px-2 py-1 flex items-center justify-between gap-x-2"
          }, [
            _createTextVNode(_toDisplayString(space.name) + " ", 1),
            _createElementVNode("i", {
              class: "pi pi-times-circle cursor-pointer",
              onClick: ($event: any) => (removeSpace(spaceIndex))
            }, null, 8, _hoisted_17)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(CButton, {
        class: "p-button-xs p-button-success",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (save()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
        ]),
        _: 1
      }),
      _createVNode(CButton, {
        class: "p-button-xs p-button-danger",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (cancel()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
        ]),
        _: 1
      })
    ])
  ], 32))
}
}

})